import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../redux/hook'
import { useIntl } from 'react-intl'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import {
    Box,
    Container,
    Text,
    Image,
    Select,
    Input,
    InputGroup,
    InputLeftElement,
    Show,
    Hide,
    Icon,
    Flex,
    Switch,
    Button,
    useDisclosure,
    RadioGroup,
    Stack,
    Radio,
    Spinner,
    useMediaQuery,
} from '@chakra-ui/react'
import { SearchIcon } from '@chakra-ui/icons'
import { CardNft } from '../../components/CollectionPage/CardNft'
import { Drawer } from '../../components/Drawer/Drawer'
import { CardLayout } from '../../components/CardItem/CardItem'
import { SortBy, SortType } from '../../components/ProfilePage/userNFTSlice'
import { getCollectionDetailPublicApi, getCollectionStatisticsPublicApi } from '../../setup/api/apiCollectionDetail'
import { CollectionStatisticsType, CollectionType } from '../../models/CollectionType'
import { getNftsByCollection, resetNFTs } from '../../components/CollectionPage/nftsCollectionSlice'
import { debounce } from 'lodash'
import InfiniteScroll from 'react-infinite-scroll-component'
import { minify } from '../../helpers/crud-helper/helpers'
import { toast } from 'react-toastify'
import { WalletContext } from '../wallet/walletContext'
import { syncOwnersCollectionApi } from '../../setup/api/apiSync'
import { URL_COLLECTION_DEFAULT } from '../../constants'

export const DEFAULT_TAKE = 10
export const DEFAULT_SKIP = 0

export const CollectionDetailPage = () => {
    const [isLg] = useMediaQuery('(min-width: 992px)')
    const intl = useIntl()
    const location = useLocation()
    const dispatch = useAppDispatch()
    const sortTypeModal = useDisclosure()
    const displayModal = useDisclosure()
    const [sortType, setSortType] = useState<SortType>(SortType.ASC)
    const [display, setDisplay] = useState('')
    const navigate = useNavigate()

    const [currentTab, setCurrentTab] = useState<string>('items')
    const [selectedLayout, setSelectedLayout] = useState<CardLayout>(CardLayout.COZY)

    const { isLogin, tokenExpiredCb } = useContext(WalletContext)

    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const { network, contractId } = useParams()
    const { data: nftData } = useAppSelector((state) => state.nftCollection)

    const [collectionDetailsData, setcollectionDetailsData] = useState<CollectionType>()

    const [collectionStatisticsData, setcollectionStatisticsData] = useState<CollectionStatisticsType>()

    useEffect(() => {
        if (!network || !contractId) return
        ;(async () => {
            const resp = await getCollectionDetailPublicApi({ network: network, contractAddress: contractId })
            if (resp) {
                setcollectionDetailsData(resp)
                const resp2 = await getCollectionStatisticsPublicApi({ network: network, contractAddress: contractId })
                setcollectionStatisticsData(resp2)
            } else {
                navigate('/')
            }
        })()
    }, [network, contractId])

    const [search, setSearch] = useState<string>()

    const searchRef = useRef(search)
    const sortTypeRef = useRef(sortType)
    const displayRef = useRef(display)

    const onSearch = () => {
        if (!network || !contractId) return
        dispatch(
            getNftsByCollection({
                name: searchRef.current,
                sortType: sortTypeRef.current,
                sortBy: SortBy.PRICE,
                take: DEFAULT_TAKE,
                skip: (nftData?.options?.currentPage || 0) * DEFAULT_TAKE,
                contractAddress: contractId,
                network: network,
                isListForSale: displayRef.current,
            })
        )
    }

    const debouncedSearch = useRef(debounce(onSearch, 300)).current

    useEffect(() => {
        if (!network || !contractId) return
        debouncedSearch()
        return () => {
            dispatch(resetNFTs())
        }
    }, [search, sortType, debouncedSearch, location.pathname, network, contractId, display])

    useEffect(() => {
        searchRef.current = search
        sortTypeRef.current = sortType
        displayRef.current = display
    }, [search, sortType, display])

    const handleCopy = (data: string) => {
        navigator.clipboard.writeText(data)
        toast.success(intl.formatMessage({ id: 'UTIL.COPIED' }), { closeButton: false })
    }

    const syncCollection = async () => {
        if (!network || !isLogin || !contractId) return
        const syncData = await syncOwnersCollectionApi({ network: network, contractAddress: contractId, tokenExpiredCb })
        if (syncData?.data?.success) {
            toast.success(intl.formatMessage({ id: 'PROFILE.SYNC.SUCCESS' }))
        }
    }

    return (
        <Container maxW={{ xxl: 1400, xl: 1200, lg: 960, md: 768, sm: 480, base: 390 }} margin={'0 auto'} p={0}>
            <Box position={'relative'} h={{ base: '244px', lg: '512px' }}>
                <Box h={{ base: '180px', lg: '440px' }}>
                    <Image
                        crossOrigin="anonymous"
                        w={'100%'}
                        h={'inherit'}
                        objectFit={'cover'}
                        src={collectionDetailsData?.banner ? collectionDetailsData?.banner : '/images/example/Rectangle.png'}
                    />
                </Box>
                <Box
                    position={'absolute'}
                    bottom={'0'}
                    left={{ base: '32px', lg: '80px' }}
                    borderRadius={{ base: 9, lg: 12 }}
                    border={{ base: '3px solid #131619', lg: '6px solid #131619' }}
                >
                    <Image
                        borderRadius={'6px'}
                        w={{ base: '96px', lg: '96px' }}
                        h={{ base: '96px', lg: '96px' }}
                        objectFit={'contain'}
                        src={collectionDetailsData?.logo ? collectionDetailsData?.logo : URL_COLLECTION_DEFAULT}
                    />
                </Box>
                {isLogin && (
                    <Box position={'absolute'} bottom={'0'} right={{ base: '0px', lg: '0px' }} borderRadius={'50%'}>
                        <Box
                            as={'button'}
                            color="#FFFFFF"
                            cursor={'pointer'}
                            rounded="6px"
                            fontSize={{ base: '16px', lg: '18px' }}
                            fontWeight="600"
                            transition="all 0.2s cubic-bezier(.08,.52,.52,1)"
                            bg={'linear-gradient(90deg, #29E9DD, #F99FAB)'}
                            p={'2px'}
                            height={{ base: '48px', lg: '48px' }}
                            _hover={{ bg: 'linear-gradient(90deg, #F99FAB, #29E9DD)', transition: 'all 0.2s cubic-bezier(.08,.52,.52,1)' }}
                            _focus={{
                                boxShadow: '0 0 1px 2px rgba(88, 144, 255, .75), 0 1px 1px rgba(0, 0, 0, .15)',
                            }}
                            _active={{
                                bg: '#dddfe2',
                                transform: 'scale(0.98)',
                                borderColor: '#bec3c9',
                            }}
                            onClick={syncCollection}
                        >
                            <Box h={'100%'} bg="#131619" rounded="4px" display={'flex'} justifyContent={'start'} alignItems={'center'} gap={'8px'}>
                                <Box
                                    px={{ base: '8px', lg: '24px' }}
                                    style={{ textWrap: 'nowrap' }}
                                    display="flex"
                                    alignItems={'center'}
                                    h={'100%'}
                                    textAlign={'center'}
                                    bgColor={'#FFFFFF0A'}
                                >
                                    <Box w={{ base: '14px', lg: '18px' }} h={{ base: '14px', lg: '18px' }} mr={{ base: '8px', lg: '12px' }}>
                                        <Icon
                                            display={'block'}
                                            w={{ base: '14px', lg: '18px' }}
                                            h={{ base: '14px', lg: '18px' }}
                                            viewBox="0 0 18 18"
                                            fill="none"
                                            color="#808489"
                                        >
                                            <path
                                                d="M15.5316 14.4722C15.6715 14.6127 15.7501 14.803 15.7501 15.0014C15.7501 15.1998 15.6715 15.3901 15.5316 15.5306C15.4294 15.6309 13.0144 18 9 18C5.49469 18 2.95031 15.9 1.5 14.2641V16.5C1.5 16.6989 1.42098 16.8897 1.28033 17.0303C1.13968 17.171 0.948912 17.25 0.75 17.25C0.551088 17.25 0.360322 17.171 0.21967 17.0303C0.0790178 16.8897 0 16.6989 0 16.5V12C0 11.8011 0.0790178 11.6103 0.21967 11.4697C0.360322 11.329 0.551088 11.25 0.75 11.25H5.25C5.44891 11.25 5.63968 11.329 5.78033 11.4697C5.92098 11.6103 6 11.8011 6 12C6 12.1989 5.92098 12.3897 5.78033 12.5303C5.63968 12.671 5.44891 12.75 5.25 12.75H2.1975C3.3525 14.1891 5.71875 16.5 9 16.5C12.375 16.5 14.4506 14.4881 14.4713 14.4675C14.6125 14.3276 14.8035 14.2495 15.0024 14.2503C15.2012 14.2512 15.3915 14.331 15.5316 14.4722ZM17.25 0.75C17.0511 0.75 16.8603 0.829018 16.7197 0.96967C16.579 1.11032 16.5 1.30109 16.5 1.5V3.73594C15.0497 2.1 12.5053 0 9 0C4.98563 0 2.57063 2.36906 2.46938 2.46938C2.3284 2.60986 2.249 2.80059 2.24865 2.99961C2.24829 3.19863 2.32702 3.38965 2.4675 3.53063C2.60798 3.6716 2.79871 3.751 2.99774 3.75135C3.19676 3.75171 3.38777 3.67298 3.52875 3.5325C3.54938 3.51187 5.625 1.5 9 1.5C12.2812 1.5 14.6475 3.81094 15.8025 5.25H12.75C12.5511 5.25 12.3603 5.32902 12.2197 5.46967C12.079 5.61032 12 5.80109 12 6C12 6.19891 12.079 6.38968 12.2197 6.53033C12.3603 6.67098 12.5511 6.75 12.75 6.75H17.25C17.4489 6.75 17.6397 6.67098 17.7803 6.53033C17.921 6.38968 18 6.19891 18 6V1.5C18 1.30109 17.921 1.11032 17.7803 0.96967C17.6397 0.829018 17.4489 0.75 17.25 0.75Z"
                                                fill="white"
                                            />
                                        </Icon>
                                    </Box>
                                    {intl.formatMessage({ id: 'PROFILE.SYNC' })}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                )}
            </Box>
            <Flex mt={{ base: '24px', lg: '24px' }} flexWrap={'wrap'} justify={'space-between'}>
                <Box w={{ base: '100%', lg: '60%' }} mb={{ base: '32px', lg: 0 }}>
                    <Flex mb={{ base: '24px', lg: '24px' }} align={'center'}>
                        <Text
                            overflow={'hidden'}
                            textOverflow={'ellipsis'}
                            whiteSpace={'nowrap'}
                            fontWeight={700}
                            fontSize={{ lg: '32px', base: '24px' }}
                        >
                            {collectionDetailsData?.name}
                        </Text>
                        <Box ml={'8px'}>
                            <Icon h={'21px'} w={'21px'} viewBox="0 0 21 21" fill="none" color="white">
                                <path
                                    d="M14.1163 6.42625C13.8806 6.18 13.6369 5.92625 13.545 5.70312C13.46 5.49875 13.455 5.16 13.45 4.83187C13.4406 4.22187 13.4306 3.53062 12.95 3.05C12.4694 2.56937 11.7781 2.55937 11.1681 2.55C10.84 2.545 10.5013 2.54 10.2969 2.455C10.0744 2.36312 9.82 2.11937 9.57375 1.88375C9.1425 1.46937 8.6525 1 8 1C7.3475 1 6.85812 1.46937 6.42625 1.88375C6.18 2.11937 5.92625 2.36312 5.70312 2.455C5.5 2.54 5.16 2.545 4.83187 2.55C4.22187 2.55937 3.53062 2.56937 3.05 3.05C2.56937 3.53062 2.5625 4.22187 2.55 4.83187C2.545 5.16 2.54 5.49875 2.455 5.70312C2.36312 5.92562 2.11937 6.18 1.88375 6.42625C1.46937 6.8575 1 7.3475 1 8C1 8.6525 1.46937 9.14187 1.88375 9.57375C2.11937 9.82 2.36312 10.0737 2.455 10.2969C2.54 10.5013 2.545 10.84 2.55 11.1681C2.55937 11.7781 2.56937 12.4694 3.05 12.95C3.53062 13.4306 4.22187 13.4406 4.83187 13.45C5.16 13.455 5.49875 13.46 5.70312 13.545C5.92562 13.6369 6.18 13.8806 6.42625 14.1163C6.8575 14.5306 7.3475 15 8 15C8.6525 15 9.14187 14.5306 9.57375 14.1163C9.82 13.8806 10.0737 13.6369 10.2969 13.545C10.5013 13.46 10.84 13.455 11.1681 13.45C11.7781 13.4406 12.4694 13.4306 12.95 12.95C13.4306 12.4694 13.4406 11.7781 13.45 11.1681C13.455 10.84 13.46 10.5013 13.545 10.2969C13.6369 10.0744 13.8806 9.82 14.1163 9.57375C14.5306 9.1425 15 8.6525 15 8C15 7.3475 14.5306 6.85812 14.1163 6.42625ZM10.8538 6.85375L7.35375 10.3538C7.30731 10.4002 7.25217 10.4371 7.19147 10.4623C7.13077 10.4874 7.06571 10.5004 7 10.5004C6.93429 10.5004 6.86923 10.4874 6.80853 10.4623C6.74783 10.4371 6.69269 10.4002 6.64625 10.3538L5.14625 8.85375C5.05243 8.75993 4.99972 8.63268 4.99972 8.5C4.99972 8.36732 5.05243 8.24007 5.14625 8.14625C5.24007 8.05243 5.36732 7.99972 5.5 7.99972C5.63268 7.99972 5.75993 8.05243 5.85375 8.14625L7 9.29313L10.1462 6.14625C10.1927 6.09979 10.2479 6.06294 10.3086 6.0378C10.3692 6.01266 10.4343 5.99972 10.5 5.99972C10.5657 5.99972 10.6308 6.01266 10.6914 6.0378C10.7521 6.06294 10.8073 6.09979 10.8538 6.14625C10.9002 6.1927 10.9371 6.24786 10.9622 6.30855C10.9873 6.36925 11.0003 6.4343 11.0003 6.5C11.0003 6.5657 10.9873 6.63075 10.9622 6.69145C10.9371 6.75214 10.9002 6.8073 10.8538 6.85375Z"
                                    fill="#2FB551"
                                />
                            </Icon>
                        </Box>
                    </Flex>
                    <Flex my={{ base: '24px', lg: '24px' }}>
                        <Box fontWeight={400} color={'#808489'}>
                            {intl.formatMessage(
                                { id: 'COLLECTION.DETAIL.CREATED_BY' },
                                {
                                    name: (
                                        <span
                                            onClick={
                                                collectionDetailsData?.creator?.fullname
                                                    ? () => {}
                                                    : () => handleCopy(collectionDetailsData?.creator?.walletAddress as string)
                                            }
                                            style={{ cursor: 'pointer', fontSize: '16px', color: '#FFFFFF' }}
                                        >
                                            {collectionDetailsData?.creator?.fullname
                                                ? collectionDetailsData?.creator?.fullname
                                                : minify(collectionDetailsData?.creator?.walletAddress as string, 6, 4)}
                                        </span>
                                    ),
                                }
                            )}
                        </Box>
                    </Flex>
                    <Text color={'#808489'} fontWeight={400} fontSize={{ lg: '16px', base: '16px' }}>
                        {collectionDetailsData?.description}
                    </Text>
                </Box>
                <Box w={{ base: '100%', lg: '35%' }}>
                    <Flex justify={'space-between'} p={{ base: '24px' }} border={'1px solid #27282A'} borderRadius={'6px'}>
                        <Box w={{ lg: '50%', base: '50%' }}>
                            {/* <Box color={'#808489'} fontWeight={400} fontSize={'16px'} mb={{ base: '12px', lg: '16px' }}>
                                {intl.formatMessage({ id: 'COLLECTION.DETAIL.TOTAL_VOLUME' })}
                            </Box> */}
                            <Box color={'#808489'} fontWeight={400} fontSize={'16px'} mb={{ base: '12px', lg: '16px' }}>
                                {intl.formatMessage({ id: 'COLLECTION.DETAIL.FLOOR_PRICE' })}
                            </Box>
                            <Box color={'#808489'} fontWeight={400} fontSize={'16px'} mb={{ base: '12px', lg: '16px' }}>
                                {intl.formatMessage({ id: 'COLLECTION.DETAIL.LISTED' })}
                            </Box>
                            <Box color={'#808489'} fontWeight={400} fontSize={'16px'}>
                                {intl.formatMessage({ id: 'COLLECTION.DETAIL.OWNERS' })}
                            </Box>
                        </Box>
                        <Box w={{ lg: '50%', base: '50%' }}>
                            {/* <Box mb={{ base: '12px', lg: '16px' }} textAlign={'end'}>
                                {collectionStatisticsData?.totalVolume || 0}
                            </Box> */}
                            <Box mb={{ base: '12px', lg: '16px' }} textAlign={'end'}>
                                {collectionStatisticsData?.floorPrice
                                    ? parseFloat(collectionStatisticsData?.floorPrice?.split(' ')?.[0]) +
                                      ' ' +
                                      collectionStatisticsData?.floorPrice?.split(' ')?.[1]
                                    : 0}
                            </Box>
                            <Box mb={{ base: '12px', lg: '16px' }} textAlign={'end'}>
                                {collectionStatisticsData?.listedTokenPercentage
                                    ? `${collectionStatisticsData?.listedTokenPercentage?.toFixed(2)} %`
                                    : '0 %'}
                            </Box>
                            <Box mb={{ base: '12px', lg: '16px' }} textAlign={'end'}>
                                {collectionStatisticsData?.owners
                                    ? `${collectionStatisticsData?.owners} (${collectionStatisticsData?.uniqueOwnerPercentage?.toFixed(2)} %)`
                                    : '0 (0 %)'}
                            </Box>
                        </Box>
                    </Flex>
                </Box>
            </Flex>
            <Box my={{ base: '32px', lg: '40px' }}>
                <Flex
                    alignItems={'center'}
                    justifyContent={{ base: 'space-between', lg: 'start' }}
                    fontWeight={600}
                    display={'flex'}
                    borderRadius={'6px'}
                    h={{ base: '40px', lg: '48px' }}
                    cursor={'pointer'}
                >
                    <Box
                        display={'flex'}
                        justifyContent={'center'}
                        alignItems={'center'}
                        w={{ base: '33%', lg: 'auto' }}
                        onClick={() => setCurrentTab('items')}
                        borderRadius={'6px'}
                        px={{ base: 0, lg: '15px' }}
                        fontSize={'16px'}
                        color={currentTab === 'items' ? '#FFFFFF' : '#808489'}
                        backgroundColor={currentTab === 'items' ? '#1C1F22' : ''}
                        minHeight={{ base: '40px', lg: '40px' }}
                    >
                        {intl.formatMessage({ id: 'COLLECTION.DETAIL.ITEMS' })}
                    </Box>
                    {/* <Box display={'flex'} justifyContent={'center'} alignItems={'center'} w={{ base: '33%', lg: 'auto' }} onClick={() => setCurrentTab('analytics')} borderRadius={'6px'} px={{ base: 0, lg: '15px' }} fontSize={'16px'} color={currentTab === 'analytics' ? '#FFFFFF' : '#808489'} backgroundColor={currentTab === 'analytics' ? '#1C1F22' : ''} minHeight={{ base: '40px', lg: '40px' }}>{intl.formatMessage({ id: 'COLLECTION.DETAIL.ANALYTICS' })}</Box>
                    <Box display={'flex'} justifyContent={'center'} alignItems={'center'} w={{ base: '33%', lg: 'auto' }} onClick={() => setCurrentTab('activity')} borderRadius={'6px'} px={{ base: 0, lg: '15px' }} fontSize={'16px'} color={currentTab === 'activity' ? '#FFFFFF' : '#808489'} backgroundColor={currentTab === 'activity' ? '#1C1F22' : ''} minHeight={{ base: '40px', lg: '40px' }}>{intl.formatMessage({ id: 'COLLECTION.DETAIL.ACTIVITY' })}</Box> */}
                </Flex>
                <Box height={'1px'} backgroundColor={'#27282A'} my={{ lg: '16px', base: '16px' }}></Box>
                <Box display={'flex'} flexDirection={{ base: 'column', lg: 'row' }} gap={'16px'}>
                    <Box w={{ lg: '100%' }} display={{ base: 'flex' }} flexDirection={{ base: 'column', lg: 'row' }} gap={{ base: '12px' }}>
                        <Box display={'flex'} w={{ base: '100%', lg: 'calc(100%)' }} h={'40px'}>
                            <InputGroup w={{ base: 'calc(100% - 52px)', lg: 'calc(70% - 16px)' }} mr={{ base: '12px', lg: '16px' }}>
                                <InputLeftElement pointerEvents="none">
                                    <SearchIcon color="gray.300" />
                                </InputLeftElement>
                                <Input
                                    type="search"
                                    placeholder={intl.formatMessage({ id: 'COLLECTION.DETAIL.SEARCH.PLACEHODER' })}
                                    onChange={(e) => setSearch(e.target.value)}
                                    value={search}
                                />
                            </InputGroup>
                            <Box w={{ base: '40px', lg: '30%' }} h={'40px'} mr={{ base: '12px', lg: '16px' }}>
                                <Hide breakpoint="(max-width: 960px)">
                                    <Select
                                        defaultValue={SortType.ASC}
                                        paddingInline={{ base: '0', lg: 'unset' }}
                                        onChange={(e) => setSortType(e.target.value as SortType)}
                                    >
                                        <option value={SortType.ASC}>{intl.formatMessage({ id: 'COLLECTION.SELECT.PRICE_LOW_TO_HIGH' })}</option>
                                        <option value={SortType.DESC}>{intl.formatMessage({ id: 'COLLECTION.SELECT.PRICE_HIGH_TO_LOW' })}</option>
                                    </Select>
                                </Hide>
                                <Show breakpoint="(max-width: 960px)">
                                    <Box w={'40px'} h={'40px'}>
                                        <Button
                                            w={'40px'}
                                            h={'40px'}
                                            display={'flex'}
                                            justifyContent={'center'}
                                            alignItems={'center'}
                                            onClick={sortTypeModal.onOpen}
                                        >
                                            <Icon display={'block'} h={'16px'} w={'16px'} viewBox="0 0 16 16" fill="none" color="#FFFFFF">
                                                <path
                                                    d="M12.5 8C12.5 8.13261 12.4473 8.25979 12.3536 8.35355C12.2598 8.44732 12.1326 8.5 12 8.5H4C3.86739 8.5 3.74021 8.44732 3.64645 8.35355C3.55268 8.25979 3.5 8.13261 3.5 8C3.5 7.86739 3.55268 7.74021 3.64645 7.64645C3.74021 7.55268 3.86739 7.5 4 7.5H12C12.1326 7.5 12.2598 7.55268 12.3536 7.64645C12.4473 7.74021 12.5 7.86739 12.5 8ZM14.5 4.5H1.5C1.36739 4.5 1.24021 4.55268 1.14645 4.64645C1.05268 4.74021 1 4.86739 1 5C1 5.13261 1.05268 5.25979 1.14645 5.35355C1.24021 5.44732 1.36739 5.5 1.5 5.5H14.5C14.6326 5.5 14.7598 5.44732 14.8536 5.35355C14.9473 5.25979 15 5.13261 15 5C15 4.86739 14.9473 4.74021 14.8536 4.64645C14.7598 4.55268 14.6326 4.5 14.5 4.5ZM9.5 10.5H6.5C6.36739 10.5 6.24021 10.5527 6.14645 10.6464C6.05268 10.7402 6 10.8674 6 11C6 11.1326 6.05268 11.2598 6.14645 11.3536C6.24021 11.4473 6.36739 11.5 6.5 11.5H9.5C9.63261 11.5 9.75979 11.4473 9.85355 11.3536C9.94732 11.2598 10 11.1326 10 11C10 10.8674 9.94732 10.7402 9.85355 10.6464C9.75979 10.5527 9.63261 10.5 9.5 10.5Z"
                                                    fill="white"
                                                />
                                            </Icon>
                                        </Button>
                                        <Drawer
                                            hContent="100px"
                                            placement="bottom"
                                            bgContent="#27282A"
                                            title={intl.formatMessage({ id: 'PROFILE.SELECT.SELECT_SORT_TYPE' })}
                                            onClose={sortTypeModal.onClose}
                                            isOpen={sortTypeModal.isOpen}
                                        >
                                            <RadioGroup
                                                onChange={(value) => setSortType(value as SortType)}
                                                value={sortType}
                                                defaultValue={SortType.ASC}
                                            >
                                                <Stack direction="row">
                                                    <Radio value={SortType.ASC}>
                                                        {intl.formatMessage({ id: 'PROFILE.SELECT.PRICE_LOW_TO_HIGH' })}
                                                    </Radio>
                                                    <Radio value={SortType.DESC}>
                                                        {intl.formatMessage({ id: 'PROFILE.SELECT.PRICE_HIGH_TO_LOW' })}
                                                    </Radio>
                                                </Stack>
                                            </RadioGroup>
                                        </Drawer>
                                    </Box>
                                </Show>
                            </Box>
                            <Box w={{ base: '40px', lg: '30%' }} h={'40px'}>
                                <Hide breakpoint="(max-width: 960px)">
                                    <Select defaultValue="" paddingInline={{ base: '0', lg: 'unset' }} onChange={(e) => setDisplay(e.target.value)}>
                                        <option value="">{intl.formatMessage({ id: 'PROFILE.SELECT.STATUS' })}</option>
                                        <option value="true">{intl.formatMessage({ id: 'NFT.LIST.FOR.SALE' })}</option>
                                    </Select>
                                </Hide>
                                <Show breakpoint="(max-width: 960px)">
                                    <Box w={'40px'} h={'40px'}>
                                        <Button
                                            w={'40px'}
                                            h={'40px'}
                                            display={'flex'}
                                            justifyContent={'center'}
                                            alignItems={'center'}
                                            onClick={displayModal.onOpen}
                                        >
                                            <Icon display={'block'} h={'16px'} w={'16px'} viewBox="0 0 24 24" fill="none" color="#FFFFFF">
                                                <g fill="currentColor">
                                                    <path d="M23.432,10.524C20.787,7.614,16.4,4.538,12,4.6,7.6,4.537,3.213,7.615.568,10.524a2.211,2.211,0,0,0,0,2.948C3.182,16.351,7.507,19.4,11.839,19.4h.308c4.347,0,8.671-3.049,11.288-5.929A2.21,2.21,0,0,0,23.432,10.524ZM7.4,12A4.6,4.6,0,1,1,12,16.6,4.6,4.6,0,0,1,7.4,12Z"></path>
                                                    <circle cx="12" cy="12" r="2"></circle>
                                                </g>
                                            </Icon>
                                        </Button>
                                        <Drawer
                                            hContent="100px"
                                            placement="bottom"
                                            bgContent="#27282A"
                                            title={intl.formatMessage({ id: 'PROFILE.SELECT.SELECT_STATUS' })}
                                            onClose={displayModal.onClose}
                                            isOpen={displayModal.isOpen}
                                        >
                                            <RadioGroup onChange={(value) => setDisplay(value)} value={display} defaultValue="">
                                                <Stack direction="row">
                                                    <Radio value="">{intl.formatMessage({ id: 'PROFILE.SELECT.STATUS' })}</Radio>
                                                    <Radio value="true">{intl.formatMessage({ id: 'NFT.LIST.FOR.SALE' })}</Radio>
                                                </Stack>
                                            </RadioGroup>
                                        </Drawer>
                                    </Box>
                                </Show>
                            </Box>
                        </Box>
                    </Box>

                    <Hide breakpoint="(max-width: 960px)">
                        <Box
                            bg={'#1C1F22'}
                            h={'40px'}
                            w={'78px'}
                            display={'flex'}
                            justifyContent={'center'}
                            alignItems={'center'}
                            borderRadius={'6px'}
                            boxSizing="border-box"
                            padding={'2px'}
                        >
                            <Box
                                display={'flex'}
                                justifyContent={'center'}
                                alignItems={'center'}
                                w={'36px'}
                                h={'36px'}
                                borderRadius={'8px'}
                                bg={selectedLayout === CardLayout.COZY ? '#131619' : '#1C1F22'}
                                cursor={'pointer'}
                                onClick={() => setSelectedLayout(CardLayout.COZY)}
                            >
                                <Icon display={'block'} h={'24px'} w={'24px'} viewBox="0 0 24 24" fill="none" color="#515458">
                                    <path
                                        d="M18.75 3.75H5.25C4.85218 3.75 4.47064 3.90804 4.18934 4.18934C3.90804 4.47064 3.75 4.85218 3.75 5.25V18.75C3.75 19.1478 3.90804 19.5294 4.18934 19.8107C4.47064 20.092 4.85218 20.25 5.25 20.25H18.75C19.1478 20.25 19.5294 20.092 19.8107 19.8107C20.092 19.5294 20.25 19.1478 20.25 18.75V5.25C20.25 4.85218 20.092 4.47064 19.8107 4.18934C19.5294 3.90804 19.1478 3.75 18.75 3.75ZM18.75 11.25H12.75V5.25H18.75V11.25ZM11.25 5.25V11.25H5.25V5.25H11.25ZM5.25 12.75H11.25V18.75H5.25V12.75ZM18.75 18.75H12.75V12.75H18.75V18.75Z"
                                        fill="white"
                                    />
                                </Icon>
                            </Box>
                            <Box
                                display={'flex'}
                                justifyContent={'center'}
                                alignItems={'center'}
                                w={'36px'}
                                h={'36px'}
                                borderRadius={'8px'}
                                bg={selectedLayout === CardLayout.COMPACT ? '#131619' : '#1C1F22'}
                                cursor={'pointer'}
                                onClick={() => setSelectedLayout(CardLayout.COMPACT)}
                            >
                                <Icon display={'block'} h={'24px'} w={'24px'} viewBox="0 0 24 24" fill="none" color="#515458">
                                    <path
                                        d="M20.25 4.5H3.75C3.35218 4.5 2.97064 4.65804 2.68934 4.93934C2.40804 5.22064 2.25 5.60218 2.25 6V18C2.25 18.3978 2.40804 18.7794 2.68934 19.0607C2.97064 19.342 3.35218 19.5 3.75 19.5H20.25C20.6478 19.5 21.0294 19.342 21.3107 19.0607C21.592 18.7794 21.75 18.3978 21.75 18V6C21.75 5.60218 21.592 5.22064 21.3107 4.93934C21.0294 4.65804 20.6478 4.5 20.25 4.5ZM9.75 13.5V10.5H14.25V13.5H9.75ZM14.25 15V18H9.75V15H14.25ZM3.75 10.5H8.25V13.5H3.75V10.5ZM9.75 9V6H14.25V9H9.75ZM15.75 10.5H20.25V13.5H15.75V10.5ZM20.25 9H15.75V6H20.25V9ZM8.25 6V9H3.75V6H8.25ZM3.75 15H8.25V18H3.75V15ZM20.25 18H15.75V15H20.25V18Z"
                                        fill="#515458"
                                    />
                                </Icon>
                            </Box>
                        </Box>
                    </Hide>
                </Box>
            </Box>
            {nftData && nftData.data?.length > 0 ? (
                <InfiniteScroll
                    dataLength={nftData.data.length}
                    next={onSearch}
                    hasMore={nftData.data.length < (nftData?.options?.totalItems as number)}
                    style={{
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        gap: isLg ? '32px' : '12px',
                        justifyContent: isLg ? 'start' : 'space-between',
                    }}
                    loader={<Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="blue.500" size="lg" />}
                >
                    {nftData.data?.map((item, index) => (
                        <CardNft key={index} nftData={item} layout={selectedLayout} />
                    ))}
                </InfiniteScroll>
            ) : (
                <>
                    <Box margin={'auto'}>
                        <Text>{intl.formatMessage({ id: 'COLLECTION.NFT.NO_NFT' })}</Text>
                    </Box>
                </>
            )}
        </Container>
    )
}
